import {
  faBasketShopping,
  faHeart,
  faSortDown,
  faStar,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Product_Info_Grid_View.css";
import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import Green_Btn from "../common_btn/green_btn/Green_Btn";
import Red_Outline_Btn from "../common_btn/red_outline_btn/Red_Outline_Btn";
import Select_Product_By_Weight_Modal from "../common_modal/select_product_by_weight_modal/Select_Product_By_Weight_Modal";
import IncrementDecrementBtn from "../Increment_Decrement_Btn/Increment_Decrement_Btn";
import { useNavigate } from "react-router-dom";
import { encodeId } from "../../../utils/common";
import { faHeart as regularHeart } from "@fortawesome/free-regular-svg-icons";
import { faHeart as solidHeart } from "@fortawesome/free-solid-svg-icons";

import { useDispatch, useSelector } from "react-redux";
import {
  getAllWishlist,
  postWishlist,
} from "../../../features/wishlist/wishlistSlice";
import { getAllCart } from "../../../features/cart/cartSlice";
import Login_Modal from "../common_modal/login_modal/Login_Modal";
import Reset_Password_Modal from "../common_modal/reset_password_modal/Reset_Password_Modal";
import Set_New_Password_Modal from "../common_modal/set_new_password_modal/Set_New_Password_Modal";
import Heart_icon from "../heart_icon/Heart_icon";
import Alert_Modal from "../common_modal/alert_modal/Alert_Modal";

const Product_Info_Grid_View = ({
  categoryId,
  setCategoryId,
  product,
  showQty,
}) => {
  const [favouriteProduct, setFavouriteProduct] = useState();
  const navigate = useNavigate();

  const [addcartmodal, Setaddcartmodal] = useState(false);
  const [showIncrement, setShowIncrement] = useState(false);
  const [liked, setLiked] = useState(false);
  const [sparkle, setSparkle] = useState(false);

  const [selectedVariant, setSelectedVariant] = useState({});
  const [variant, setVariant] = useState({});
  const isSignin = useSelector((state) => state.auth.is_signin);
  const allCart = useSelector((state) => state.cart.allCarts);

  const dispatch = useDispatch();

  // useEffect(() => {
  //   dispatch(getAllCart(isSignin));
  // }, []);

  const toggleLike = () => {
    setLiked((prev) => !prev);

    if (!liked) {
      setSparkle(true);
      setTimeout(() => setSparkle(false), 800);
    }
  };

  const isIn = allCart?.data?.data?.some(
    (item) => item?.variant_id === selectedVariant?.id
  );

  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showResetModal, setShowResetModal] = useState(false);
  const [showSetPassModal, setShowSetPassModal] = useState(false);

  const [showAccountCreted, setShowAccountCreted] = useState(false);
  const [isLogedIn, setIsLogedIn] = useState(false);
  const [email, setEmail] = useState();
  const [contact, setContact] = useState();
  const [showSuccessModal, setShowSucsessModal] = useState(false);

  const taxPercent = Number(product?.tax_percentage);
  const basePrice = Number(product?.Product_Variants[0]?.price || 0);
  const basePricemrp = Number(product?.Product_Variants[0]?.mrp || 0);
  const taxAmount = (basePrice * taxPercent) / 100;
  const taxAmountmrp = (basePricemrp * taxPercent) / 100;
  const finalSellingPrice = basePrice + taxAmount;
  const finalSellingmrp = basePricemrp + taxAmountmrp;

  const [modalShow, setModalShow] = React.useState(false);
  const handleCategoryClick = () => {
    if (product?.eight_plus_status) {
      // Show modal if eight_plus_status is true
      setModalShow(true);
    } else {
      // Directly navigate if not
      navigate(
        `/product-description/${encodeId(product?.id)}?category_name=${encodeURIComponent(
          product?.p_category?.name
        )}&category_image=${encodeURIComponent(product?.p_category?.image)}`
      );
    }
  };
  return (
    <section className="Product_Info_Grid_View_Section">
      <div className="Product_Info_Grid_View">
        <div
          className="upper_image_section"
          onClick={handleCategoryClick}
          // onClick={() => navigate(`/product-description/${product?.id}`)}
        >
          <div className="card_img_holder">
            <img
              className=""
              src={process.env.REACT_APP_IMG_URL + product?.image}
              alt={product?.product_name}
            />
          </div>

          <div className="text_div">
            <div className="discont_div">
              <p className="discount_text">
                {Math.round(
                  ((product?.Product_Variants[0]?.mrp -
                    product?.Product_Variants[0]?.price) /
                    product?.Product_Variants[0]?.mrp) *
                    100
                )}
                % Off
              </p>
            </div>
          </div>
        </div>

        <div className="lower_text_section">
          <p
            className="product_name"
            onClick={() => navigate(`/product-description/${encodeId(product?.id)}`)}
          >
            {product?.name}
          </p>

          <div className="pricing_div">
            <div className="left_side">
              <p className="selling_price">
                ₹ {Number(product?.Product_Variants[0]?.price || 0)}
              </p>
              <p className="mrp">
                ₹ {Number(product?.Product_Variants[0]?.mrp || 0)}
              </p>
              {/* <div className='discount_div'>
                                <p className='discount'>{product?.discount}</p>
                            </div> */}
            </div>

            {showQty && (
              <div className="kilo_main_div">
                <div
                  className="kilo_div"
                  type="button"
                  onClick={() => Setaddcartmodal(true)}
                >
                  <div>
                    <p className="kilo_text">
                      {product?.Product_Variants[0]?.name}
                      {product?.Unit?.name}
                    </p>
                  </div>
                  <div>
                    <p className="icon_p">
                      <FontAwesomeIcon
                        icon={faSortDown}
                        className="down_icon"
                      />
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="text-center btn_holder">
            {/* {!product?.outofStock ? ( */}
            <>
              {isIn ? (
                <IncrementDecrementBtn
                  varientId={selectedVariant?.id}
                  cart={allCart?.data?.data}
                  productId={product?.id}
                  product={product}
                  isSignIn={isSignin}
                />
              ) : (
                <div className="">
                  <Green_Btn
                    btn_name="Add to Cart"
                    leftIcon={faBasketShopping}
                    onClick={() => {
                      setShowIncrement(true);
                      Setaddcartmodal(true);
                    }}
                  />
                </div>
              )}
            </>
            {/* ) : (
              <div className="">
                <Red_Outline_Btn btn_name="Out of Stock" />
              </div>
            )} */}
          </div>
          <Heart_icon product={product} />
        </div>

        <Select_Product_By_Weight_Modal
          varient={product?.Product_Variants}
          selectedVariant={selectedVariant}
          setSelectedVariant={setSelectedVariant}
          product={product}
          show={addcartmodal}
          onHide={() => Setaddcartmodal(false)}
        />
      </div>

      <Login_Modal
        show={showLoginModal}
        onHide={() => {
          setShowLoginModal(false);
        }}
        loginDone={() => {
          setIsLogedIn(true);
        }}
        setShowResetModal={() => setShowResetModal(true)}
        setShowAccountCreted={() => setShowAccountCreted(true)}
      />

      <Reset_Password_Modal
        email={email}
        setEmail={setEmail}
        contact={contact}
        setContact={setContact}
        show={showResetModal}
        onHide={() => {
          setShowResetModal(false);
        }}
        setShowSetPassModal={() => setShowSetPassModal(true)}
      />

      <Set_New_Password_Modal
        email={email}
        setEmail={setEmail}
        contact={contact}
        setContact={setContact}
        show={showSetPassModal}
        onHide={() => {
          setShowSetPassModal(false);
        }}
        setShowSucsessModal={() => setShowSucsessModal(true)}
      />

      <Alert_Modal
        url={`/product-description/${encodeId(product?.id)}?category_name=${encodeURIComponent(
          product?.p_category?.name
        )}&category_image=${encodeURIComponent(product?.p_category?.image)}`}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </section>
  );
};

export default Product_Info_Grid_View;
